<template>
    <div class="customer-profile registration-customer-form">
        <div class="content-area">
            <base-header
                :menu-listing="getMenuListing"
                step-style
                @sidemenu="$emit('responsiveSideBar')"
            ></base-header>
            <div class="right-panel">
                <div class="wrap-content customer-section">
                    <div class="filter-section">
                        <div class="row">
                            <div class="col-md-12">
                                <h2>{{ $route.meta.name }}</h2>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <page-loader
                                v-if="showPageLoader"
                        ></page-loader>
                        <uae-pass-confirmation-popup
                                title="Customer Onboarding"
                                :description=customMessage
                                cancelText ="Continue without UAE PASS"
                                :onCancel=stayOnThisPage
                                :onConfrim=uaePassRedirect
                                :redirectUrl=uaePassURL
                                :isUaePassValue=isUaePass
                                
                        >
                        </uae-pass-confirmation-popup>
                        <router-view></router-view>
                        <b-modal
                            ref="modalError"
                            size="md"
                            title="Welcome to Idenfo Direct"
                            hide-footer
                            hide-header-close
                            :click-to-close="false"
                            :no-close-on-backdrop="true"
                            :no-close-on-esc="true"
                        >
                            <div class="modal-body-disclaimer">
                                <p class="paragraph">
                                    Your profile limit has been exceeded!
                                </p>
                                <div class="row justify-content-center">
                                    <div class="m-2">
                                        <b-button
                                            variant="secondary"
                                            @click="currentPlan"
                                            >Okay</b-button
                                        >
                                    </div>
                                </div>
                            </div>
                        </b-modal>

                    </div>
                  <div class="poweredBy mt-2" v-if="idenfoLogo">
                  <p style="margin: 0">Powered By</p>
                  <img :src="idenfoLogo" />
                  </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import request from '@/utils/request'
import resource from '@/api/resource'
import axios from 'axios'

const modulesApi = new resource('configurations/modules')
import PageLoader from "../../components/PageLoader"
import UaePassConfirmationPopup from "../../components/popups/UaePassConfirmationPopup";

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    components: {
      PageLoader, UaePassConfirmationPopup
    },

    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
          idenfoLogo: '',

          country:process.env.VUE_APP_COUNTRY_TEMP,
            soundeffect: new Audio(),
            liveness: null,
            nameScreening: null,
            riskFactor: null,
            documentUpload: null,
            accountinfo:null,
            isUaePass:null,
            menuListing: [
                {
                    // anchorLink: '/register-customer/upload-document',
                    menuLabel: 'Upload Documents',
                    sessionStep: '1',
                    name: 'upload-document',
                    permission: ['register-customer'],
                },
                {
                    // anchorLink: '/register-customer/record-video',
                    menuLabel: 'Record Video',
                    sessionStep: '2',
                    name: 'upload-document',
                    permission: ['register-customer'],
                },
                {
                    // anchorLink: '/register-customer/setup-profile',
                    menuLabel: 'Setup Profile',
                    sessionStep: '3',
                    name: 'upload-document',
                    permission: ['register-customer'],
                },
                {
                    // anchorLink: '/register-customer/account-info',
                    menuLabel: 'Account Info',
                    sessionStep: '4',
                    name: 'upload-document',
                    permission: ['register-customer'],
                },
                {
                    menuLabel: 'Additional Info',
                    sessionStep: '5',
                    name: 'upload-document',
                    permission: ['register-customer'],
                },
                {
                    // anchorLink: '/register-customer/account-info',
                    menuLabel: 'Preview',
                    sessionStep: '6',
                    name: 'upload-document',
                    permission: ['register-customer'],
                },
                {
                    // anchorLink: '/register-customer/finish',
                    menuLabel: 'Finish',
                    sessionStep: '7',
                    name: 'upload-document',
                    permission: ['register-customer'],
                },
            ],
            userCompanyType: '',
            configData: {
                dataSegmentId: null,
                riskFactor: null,
                liveness: null,
                nameScreening: null,
                documentUpload: null,
                companyType: null,
                isUaePass:null,
                accountinfo:null,
                counter: null,
                subscription: null,
                tier: null,
                restrictDuplicateCustomers: null,
            },
            customersCount: 0,
            // showPageLoader: true,
            query: {
                startAt: 1,
                keyword: '',
                perPage: 10,
                status: null,
                sortBy: 'idenfoId',
                sortOrder: 'desc',
            },
            customMessage: "Verify yourself by using UAE Pass",
            // uaePassRedirectURL:"https://uaedirectuat.idenfo.com/api/users/uae-pass-callback",
            uaePassRedirectURL:process.env.VUE_APP_API_URL+"users/uae-pass-callback",
            clientId:process.env.VUE_APP_UAE_PASS_ID,
            uaePassURL:"",
            
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['form', 'dataSegmentId','showPageLoader','uaePassObject','displaySettings']),

        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
              if(this.displaySettings.clientLogo && this.$route.path.includes('deep-register')) {
                this.idenfoLogo = this.displaySettings
                    ? `${process.env.VUE_APP_API_URL}files/logo/${this.displaySettings.logo.light.fileName}`
                    : ''
              }
                this.$store.commit('setDataSegmentId',this.$route.params.dataSegmentId)
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },

        // userToken() {
        //     if (this.$route.params.token) {
        //         return this.$route.params.token
        //     }
        //     return this.$store.getters.token
        // },

        getMenuListing() {
            let arr = this.menuListing
            for (var key in arr) {
                if (this.documentUpload == false && arr[key].sessionStep == 1) {
                    arr.splice(key, 1)
                }
                if (
                    (this.liveness == false ||
                        this.$store.getters.form.type == 'company')  &&
                    arr[key].sessionStep == 2
                ) {
                    arr.splice(key, 1)
                }
                if (this.nameScreening == false && arr[key].sessionStep == 3) {
                    arr.splice(key, 1)
                }
                if (this.configData.accountinfo ==false && arr[key].sessionStep == 4) {
                    arr.splice(key, 1)
                }
                if (
                    (this.configData.additionalInfo == false ||
                        this.$store.getters.form.type == 'company') &&
                    arr[key].sessionStep == 5
                ) {
                    arr.splice(key, 1)
                }
                // if (this.userCompanyType == 'non-financial' && arr[key].sessionStep == 4) {
                //     arr.splice(key, 1)
                // }
            }
            return arr
        },
    }, // End of Component > mounted

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.goToFirstStep()
                //    this.checkOcrSwitch()
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */

    async created(){
        // if(this.$route.query && this.$route.query.code)
        // {
        //     this.$store.commit('showPageLoader', true)
        //     await this.uaePassLogin(this.$route.query.code)
        // }
        // else
        // {
        //     let token =this.$route.params.token
        //     this.uaePassURL ="https://stg-id.uaepass.ae/idshub/authorize?redirect_uri="+this.uaePassRedirectURL+"&client_id="+this.clientId+"&response_type=code&state="+token+"&scope=urn:uae:digitalid:profile:general urn:uae:digitalid:profile:general:profileType urn:uae:digitalid:profile:general:unifiedId&acr_values=urn:safelayer:tws:policies:authentication:level:low"
        //     console.log('---created---',token)
        //
        //     this.$bvModal.show('uae-pass-confirmation-popup')
        // }
    },

    async mounted() {
        this.$store.commit('initDefaultFields', 'form')
        // console.log('-------------im customer forms', this.$store.getters.form)
        // console.log('----code----',this.$route.query.code)

        if(this.$route.query && this.$route.query.code)
        {
            this.$store.commit('showPageLoader', true)
            await this.uaePassLogin(this.$route.query.code)
        }
        else
        {
            if(process.env.VUE_APP_UAE_PASS=='true')
            {
                // add condition for UAE only
                let token =this.dataSegmentId + "-"+this.$route.params.token
                this.uaePassURL =process.env.VUE_APP_UAE_PASS_URL+"idshub/authorize?redirect_uri="+this.uaePassRedirectURL+"&client_id="+this.clientId+"&response_type=code&state="+token+"&scope=urn:uae:digitalid:profile:general urn:uae:digitalid:profile:general:profileType urn:uae:digitalid:profile:general:unifiedId&acr_values=urn:safelayer:tws:policies:authentication:level:low"
                // console.log('---mounted---',token)

                this.$bvModal.show('uae-pass-confirmation-popup')
            }

        }

        await this.soundon()
        await this.goToFirstStep()
        if (this.$route.path.includes('deep')) {
            await this.checkTempUser()
        } else {
            await this.checkDataSegment()
        }
        await this.getModuleData()
        await this.getCounter()

        //  this.checkOcrSwitch()
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        /**
         * go to the first step
         *
         * @return {void}
         */

        // functions for UAE Pass
        async uaePassLogin(code)
        {
            console.log('----calling------')
            let param = "code="+code
            if(this.$route.query.token)
            {
                param="accessToken="+code
            }
            let data =  await axios.get(`${process.env.VUE_APP_API_URL}users/uae-pass-info?${param}`)
                .then(function (response) {
                    return response
                })

                .catch(function (error) {
                    console.log('uae pass login error',error);
                });
            console.log('--------response------',data)
            if(data && data.status==200)
            {
                if(data.data)
                {
                    if(data.data.status)
                    {
                        this.$store.commit('setUaePassObject',data.data.data)

                        // update form fields
                        // this.$store.commit('updateField', {
                        //     key: 'contactInfo.email',
                        //     value: this.uaePassObject.email,
                        // })
                        // this.$store.commit('updateField', {
                        //     key: 'contactInfo.confirmEmail',
                        //     value: this.uaePassObject.confirmEmail,
                        // })

                        // set the whole object
                        this.$store.commit('updateField', {
                            key: 'uaePassDetails',
                            value: this.uaePassObject,
                        })
                        console.log('---store value----',this.$store.state.registration.form.uaePassDetails)


                        this.$store.commit('updateField', {
                            key: 'basicInfo.firstName',
                            value: this.uaePassObject.fullnameEN,
                        })
                        this.$store.commit('updateField', {
                            key: 'contactInfo.phoneNumber',
                            value: this.uaePassObject.mobile,
                        })

                        if(this.uaePassObject.idn)
                        {
                            this.$store.commit('updateField', {
                                key: 'identityInfo.number',
                                value: this.uaePassObject.idn,
                            })
                        }

                        if(this.uaePassObject.gender && (this.uaePassObject.gender=='Male' || this.uaePassObject.gender=='Female'))
                        {
                            let genders = await this.getRecords('genders')

                            let genderId = ''
                            let genderType = ''
                            if (genders) {
                                genders.forEach((element) => {
                                    if (element.title == this.uaePassObject.gender) {
                                        genderId = element._id
                                        genderType = element.title
                                    }
                                })
                            }
                            this.$store.commit('updateField', {
                                key: 'basicInfo.gender',
                                value: genderType,
                            })
                            this.$store.commit('updateField', {
                                key: 'basicInfo.genderId',
                                value: genderId,
                            })
                        }

                        if(this.uaePassObject.nationalityEN)
                        {
                            let nationality = null
                            let nationalityId = null
                            let nationalities = await this.getRecords('nationalities')
                            if (nationalities) {
                                nationalities.forEach((element) => {
                                    if (element.uaePassCode == this.uaePassObject.nationalityEN) {
                                        nationalityId = element._id
                                        nationality = element.title
                                    }
                                })

                                this.$store.commit('updateField', {
                                    key: 'basicInfo.nationality',
                                    value: nationality,
                                })
                                this.$store.commit('updateField', {
                                    key: 'basicInfo.nationalityId',
                                    value: nationalityId,
                                })
                            }
                        }

                        this.$store.commit('showPageLoader', false)
                        return
                    }
                }
            }
            this.$store.commit('setError', "Something went wrong")
            this.$store.commit('showPageLoader', false)
        },
        uaePassRedirect()
        {
            window.location.assign(this.uaePassURL)
        },
        stayOnThisPage(){
            this.$bvModal.hide('uae-pass-confirmation-popup')
        },
     
        isUaePassValue(){
            console.log("isUaePassValue",isUaePassValue)
            return true
        },
        async getRecords(association) {
            try {
                // fetch the list of associated configurations
                let { data } = await request({
                    url: `/configurations/${association}`,
                    params: {
                        dataSegmentId: this.dataSegmentId,
                        status: 'active',
                        perPage: 1000,
                        ref: 'dropdown',
                    },
                })

                // update the local list of options
                return data.data
                //  console.log('this.associateData', this.associateData)
            } catch (error) {
                console.log(error)
            }
        }, // End of getRecords() method

        async getModuleData() {
            try {
                if (this.dataSegmentId) {
                    let { data } = await modulesApi.list({
                        dataSegmentId: this.dataSegmentId,
                    })
                    if (!_.isEmpty(data.data)) {
                        this.liveness = data.data.liveness
                        this.nameScreening = data.data.nameScreening
                        this.riskFactor = data.data.riskFactor
                        this.documentUpload = data.data.documentUpload
                        this.isUaePass=data.data.isUaePass
                        this.accountinfo=data.data.accountinfo
                        this.$store.state.configData = data.data
                        this.configData = data.data
                        this.$store.state.registration.configData = data.data
                        // console.log('configData', this.configData)
                    }
                }
            } catch (error) {
                console.log(error)
            }
        },
        goToFirstStep() {
            if (
                ![
                    'upload-document',
                    'deep-registration-upload-document',
                ].includes(this.$route.name)
            ) {
                if (this.$route.meta.publicRegistration === true) {
                    this.$router.push({
                        name: 'deep-registration-upload-document',
                        params: {
                            dataSegmentId: this.dataSegmentId,
                        },
                    })
                } else {
                    this.$router.push({
                        name: 'upload-document',
                    })
                }
            }
        }, // End of goToFirstStep() method
        soundon() {
            const sound =
                'data:audio/mpeg;base64,SUQzBAAAAAABEVRYWFgAAAAtAAADY29tbWVudABCaWdTb3VuZEJhbmsuY29tIC8gTGFTb25vdGhlcXVlLm9yZwBURU5DAAAAHQAAA1N3aXRjaCBQbHVzIMKpIE5DSCBTb2Z0d2FyZQBUSVQyAAAABgAAAzIyMzUAVFNTRQAAAA8AAANMYXZmNTcuODMuMTAwAAAAAAAAAAAAAAD/80DEAAAAA0gAAAAATEFNRTMuMTAwVVVVVVVVVVVVVUxBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQsRbAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQMSkAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV'
            this.soundeffect.src = sound
            this.$store.commit('updateField', {
                key: 'soundSrc',
                value: this.soundeffect,
            })
        },
        /**
         * check if the ocr switch configurations
         * is on for this data segment
         *
         * @return {void}
         */
        async checkTempUser() {
            try {
                let params = this.$route.params
                let dataSegmentId = params.dataSegmentId
                let userToken = params.token
                // console.log(params)

                const formData = {
                    userToken: userToken,
                    dataSegmentId: dataSegmentId,
                }

                let { data } = await request({
                    url: `/customers/temp-customer-exists`,
                    method: 'post',
                    data: formData,
                })

                if (data) {
                    console.log('Response: ' + JSON.stringify(data))
                    console.log('Response: ' + JSON.stringify(data.exists))
                    if (!data.exists) {
                        this.$router.push({
                            name: '/404',
                        })
                    }
                }
            } catch (error) {
                // console.log(error)
            }
        },

        async checkDataSegment() {
            try {
                let params = this.$route.params
                let dataSegmentId = params.dataSegmentId

                const formData = {
                    dataSegmentId: dataSegmentId,
                }

                let { data } = await request({
                    url: `/customers/data-segment-exists`,
                    method: 'post',
                    data: formData,
                })

                if (data) {
                    // console.log('Response: ' + JSON.stringify(data))
                    // console.log('Response: ' + JSON.stringify(data.exists))
                    if (!data.exists) {
                        this.$router.push({
                            name: '/404',
                        })
                    }
                }
            } catch (error) {
                console.log(error)
            }
        },
        // End of checkOcrSwitch() method

        async getUserByDataSegmentId() {
            // console.log('GetUSer')

            let { data } = await request({
                url: `/users/getUserByDataSegmentId/${this.dataSegmentId}`,
                method: 'get',
            })

            if (data) {
                // console.log(data)
                this.userCompanyType = data.data.companyType

                this.$store.commit('updateField', {
                    key: 'companyType',
                    value: this.userCompanyType,
                })
            }
        },

        async checkCustomersCount() {
            try {
                let params = this.$route.params
                let dataSegmentId = params.dataSegmentId

                const formData = {
                    dataSegmentId: dataSegmentId,
                }

                let { data } = await request({
                    url: `/customers/count`,
                    method: 'post',
                    data: formData,
                })

                if (data) {
                    // console.log('Response: ' + JSON.stringify(data))
                    this.customersCount = data.data
                }
            } catch (error) {
                console.log(error)
            }
        },

        async getCounter() {
            if (this.configData.subscription == 'unpaid') {
                this.configData.counter = 0
            }

            this.$store.commit('showPageLoader', true)
            try {
                this.resourceApi = new resource('users/count-applications')
                let params = {
                    dataSegmentId: this.dataSegmentId,
                }
                let { data } = await this.resourceApi.list(params)
                if (data && data.tierAttains) {
                    this.$refs.modalError.show()
                }
                // False the page loader after the list has been loaded
                this.$store.commit('showPageLoader', false)
                this.$store.commit('setLoading', false)
            } catch (error) {
                this.$store.commit('showPageLoader', false)
                this.$store.commit('setLoading', false)
                // this.$store.commit('setError', error)
            }
        },

        payments() {
            this.$refs.modalError.hide()
            this.$router.push('/billing')
        },
        currentPlan() {
            this.$refs.modalError.hide()
            this.$router.push('/customer-profiles')
        },
    }, // End of Component > watch
} // End of export default
</script>
<style scoped>
.poweredBy{
  max-width: 80px !important;
  margin: auto
}
</style>
